export const appRoute = {
  home : "home",
  validate: "validate",
  biDashboard: "bi-dashboard",
};

export const FacilityGuardMessages = {
  navigationError: 'Navigation Error',
  facilityMismatch: 'Facility Mismatch',
  facilityMismatchMessage: "The information you're trying to view belongs to a different facility than the one currently selected. Please return to the previous page,  Please switch to the correct facility and try again.",
};

export const FACILITY_ID = 'facilityId';